import { Directive, HostListener, ElementRef, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[libEnforcePointSeparator]',
})
export class EnforcePointSeparatorDirective {
    private attachedInput: HTMLInputElement;

    constructor(
        el: ElementRef,
        @Optional() @Self() private ngControl: NgControl,
    ) {
        this.attachedInput = el.nativeElement;
    }

    @HostListener('input') onInput() {
        if (this.attachedInput) {
            const raw = this.attachedInput.value;
            const normalized = raw.replace(/,/g, '.');
            if (normalized !== raw) {
                const cursorPos = this.attachedInput.selectionStart;
                this.attachedInput.value = normalized;
                this.attachedInput.setSelectionRange(cursorPos, cursorPos);
            }
            if (this.ngControl?.control) {
                const num = parseFloat(normalized);
                this.ngControl.control.setValue(isNaN(num) ? null : num, {
                    emitEvent: true,
                    emitModelToViewChange: false,
                });
            }
        }
    }
}
